import React, {Component} from 'react';
import {Modal, Table} from 'react-bootstrap';
import {translate} from 'react-i18next';
import swal from 'sweetalert';
import FlatButton from 'material-ui/FlatButton';
import moment from 'moment';
import SvgIcon from 'react-icons-kit';
import {bin} from 'react-icons-kit/icomoon/bin';

var Config = require('../../../config');

class ModalSample extends Component{
	constructor(props){
		super(props);

		this.handleShow = this.handleShow.bind(this);
		this.handleClose = this.handleClose.bind(this);
		this.getSamples = this.getSamples.bind(this);

		this.state = {
			show: false,
			samples:[],
			petition_id:"",
		}
	}

	componentDidMount(){
		this.props.onRef(this);
	}

	componentWillUnmount(){
		this.props.onRef(null);
	}

	handleShow(petition_id){
	
		this.getSamples(petition_id)
		this.setState({
			petition_id:petition_id
		});
	}

	getSamples(id){
		this.props.waiting.handleShow('Cargando...');

		fetch(Config.default.apiGateway.URL+'petitions/get_samples?petition_id='+id, {
			method: 'get',
			headers: new Headers({
				'Authorization'	: 'Bearer '+sessionStorage.getItem('token'),
				'Accept'		: 'application/json',
				'Content-Type'	: 'application/json'
			})
		}).then(res => {
			this.props.waiting.handleClose();
			if(res.ok){
				return res.json();
			}else{
				res.text().then((msg)=>{
					swal('Error', msg, 'error');
				});
			}
		}).then(response =>{
			if(response !== undefined){
				if(response.length > 1){
					this.setState({samples: response, show:true});
				}else if(response.length > 0){
					this.props.selectLabel(null, response[0].sample.id, response[0].petition_has_sample.petitions_id);
				}else{
					swal('Alerta', 'La muestras se encuentran caducadas', 'warning')
				}
				
			
			}
		});
	}

	handleClose(){
		this.setState({show:false});
	}

	

	

	render(){
		const {t} = this.props;
		return (
			<Modal bsSize="sm" show={this.state.show} onHide={this.handleClose}>
		       	<Modal.Header closeButton>
		        	<Modal.Title>Muestras</Modal.Title>
		        </Modal.Header>
		        <Modal.Body >
		        	<div className="row">
		        		<div className="col-xs-12">
		        			<div className="col-xs-12 col-sm-offset-1 col-sm-10">
				        		<Table responsive hover>
				        			<thead>
				        				<tr>
				        					<th>Muestra</th>
				        				</tr>
				        			</thead>
				        			<tbody>
					        			{this.state.samples.map((s, i)=>(
						        			<tr key={i}>
						        				<td>
						        					<a href="" onClick={(e)=>this.props.selectLabel(e, s.sample.id, s.petition_has_sample.petitions_id)} >
						        						{s.sample.number}
						        					</a>
						        				</td>
						        			</tr>
						        		))}
					        		</tbody>
				        		</Table>
			        		</div>
		        		</div>
		        	</div>
		        </Modal.Body>
		        <Modal.Footer>
		        	
		        	<FlatButton primary={true} label={t('content.generics.buttons.reset')}  onClick={this.handleClose}/>
		        </Modal.Footer>
	      	</Modal>
		)
	}
}

export default translate('translations')(ModalSample)